export type FleetCheckExportState = {
  scanWindow: { from: Date; to: Date } | null;
  isScanRunning: boolean;
  scanFailed: boolean;
  rowCount: number;
  lookupsLoading: boolean;
  enrichmentLoading: boolean;
  errors: { devices: boolean; statusInfo: boolean; vins: boolean; lookups: boolean };
};

/**
 * Nothing to export before a scan finished, not after it failed, and not while the names the checks match on are
 * missing: the sheet would report vehicles as incomplete that are not. A failed vehicle list, unit
 * status or VIN lookup, or one still loading, would leave its columns empty or wrong in the sheet.
 */
export function isFleetCheckExportDisabled(state: FleetCheckExportState): boolean {
  const { errors } = state;
  return (
    state.scanWindow === null ||
    state.isScanRunning ||
    state.scanFailed ||
    state.rowCount === 0 ||
    state.lookupsLoading ||
    state.enrichmentLoading ||
    errors.lookups ||
    errors.devices ||
    errors.statusInfo ||
    errors.vins
  );
}
